<template>
  <div class="clubHistory">
    <dl class="clubHistory__container">
      <dt class="clubHistory__title">
        <svg class="clubHistory__titleImg" width="12" height="12" viewBox="0 0 12 12" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M10.3207 0.00012207H0.991061C0.442812 0.00012207 0 0.442948 0 0.991197V10.3208C0 10.8691 0.442812 11.3119 0.991061 11.3119H10.3207C10.8689 11.3119 11.3117 10.8691 11.3117 10.3208V0.991197C11.3117 0.442948 10.8689 0.00012207 10.3207 0.00012207Z"
              fill="white" fill-opacity="0.45"/>
        </svg>
        История создания
      </dt>
      <dd class="clubHistory__description">
        <strong> Клуб был основан командой Кибердеда в 2022 году. Он возник из идеи </strong>
        собрать под одной крышей практиков и энтузиастов OSINT, специалистов по информационной безопасности и тех, кто
        хочет учиться мыслить шире — через призму киберкультуры и цифровой философии.
        <div class="clubHistory__indicators">
          <dl class="digitIndicator">
            <dt>50+</dt>
            <dd>участников клуба</dd>
          </dl>
          <dl class="digitIndicator">
            <dt>100+</dt>
            <dd>мероприятий проведено</dd>
          </dl>
          <dl class="digitIndicator">
            <dt>2304+</dt>
            <dd>сообщений в месяц в закрытом чате</dd>
          </dl>
        </div>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: "ClubHistory"
}
</script>


<style scoped lang="scss">
.clubHistory {
  margin-left: 32px;
  text-align: left;

  @include respond-to('md') { margin-left: 0; }

  &__container {
    display: flex;
    align-items: flex-start;
    gap: $space-md;

    @include respond-to('md') { flex-direction: column; }
  }

  &__title {
    display: flex;
    align-items: center;
    min-width: 200px;
    gap: 13px;
    text-transform: uppercase;
    color: var(--cd-text-muted);
    font-size: 16px;
    font-family: var(--cd-default-font);
    flex-shrink: 0;
  }

  &__titleImg {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
  }

  &__description {
    font-family: var(--cd-bold-font);
    font-size: clamp(18px, 3vw, 28px);
    font-weight: 500;

    strong { color: var(--cd-text-muted); }
  }

  &__indicators {
    padding: 40px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    color: var(--cd-text-muted);

    @include respond-to('sm') { gap: 24px; padding: 24px 0; }
  }
}

.digitIndicator {
  display: flex;
  flex-direction: column;
  text-align: left;

  dt {
    font-family: var(--cd-bold-font);
    font-size: clamp(40px, 7vw, 70px);
    font-weight: 500;
  }

  dd {
    margin: 0;
    font-family: var(--cd-default-font);
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
